/*
 * @Author: Json Chen
 * @Date: 2021-06-28 10:00:19
 * @LastEditTime: 2022-06-02 14:29:44
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeDefaultTable.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import React from 'react';
import styles from '../style.module.less';
import ProductAttributeDefaultModalForm from './ProductAttributeDefaultModalForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ProductAttributeDefaultTable = ({
  value: attrTableData = [],
  onChange,
  disabled,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [attrVisible, setAttrVisible] = React.useState<boolean>(false);
  const [attrIndex, setAttrIndex] = React.useState<number>(-1);
  const onAttrActionEditClick = (column, index) => {
    setAttrIndex(index);
    setAttrVisible(true);
  };
  const hideAttrModal = () => {
    setAttrVisible(false);
    setAttrIndex(-1);
  };

  const onModalConfirm = (data) => {
    onChange(data);
    hideAttrModal();
  };

  const attrColumns = [
    {
      title: getI18n('storeProductSetting.detail.attributeTitle'),
      key: 'title',
      dataIndex: 'title',
      default: true,
      width: 320,
      childGenerate: (text) => {
        return <div className={styles.tb}>{text}</div>;
      },
    },
    {
      title: getI18n('storeProductSetting.detail.attributeOptions'),
      dataIndex: 'options',
      key: 'options',
      default: true,
      width: 640,
      textWrap: 'word-break',
      childGenerate: (option, record) => {
        return (
          <div className={styles.tb}>
            {(record.defaultOptions || [])
              .map((o) => o[record.inputKey])
              .concat(record.options.map((o) => o[record.inputKey]))
              .join(' , ')}
          </div>
        );
      },
    },

    disabled
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          default: true,
          optional: true,
          align: 'center',
          width: 128,
          childGenerate: (_, record, index) => {
            return (
              <div className={styles.action}>
                <span
                  className={styles.primary}
                  onClick={() => onAttrActionEditClick(record, index)}>
                  {getI18n('general.edit')}
                </span>
              </div>
            );
          },
        },
  ];

  return (
    <>
      <SizeFittingTable
        rowKey='title'
        pagination={false}
        id='StoreSettingsProductAttributeDefault'
        className={styles.table}
        dataSource={attrTableData}
        columns={attrColumns}
      />

      <ProductAttributeDefaultModalForm
        visible={attrVisible}
        attrData={attrTableData}
        attrIndex={attrIndex}
        onCancel={hideAttrModal}
        onModalConfirm={onModalConfirm}
      />
    </>
  );
};

export default ProductAttributeDefaultTable;
